/* global Modernizr */

import { Controller } from 'stimulus';
import Awesomplete from 'awesomplete';
import throttle from '../helpers/throttle';
import debounce from '../helpers/debounce';

const BREAKPOINT = 992;

const KEY_LEFT = 37;
const KEY_RIGHT = 39;
const KEY_DOWN = 40;
const KEY_UP = 38;
const KEY_SHIFT = 16;
const KEY_ESCAPE = 27;

const IGNORED_KEYS = [KEY_UP, KEY_DOWN, KEY_RIGHT, KEY_LEFT, KEY_SHIFT, KEY_ESCAPE];

class Search extends Controller {
  connect() {
    this.awesomplete = new Awesomplete(this.inputTarget, {
      maxItems: 6,
      minChars: 3,
      list: [],
      filter: Search.filter,
      item: Search.item,
      replace: this.replace.bind(this),
      sort: () => 0,
    });

    this.debouncedSearch = debounce(this.search.bind(this), 250);
    this.throttledResize = throttle(this.changePlaceholder.bind(this), 150);
    this.onResize();
  }

  static filter() {
    return true;
  }

  static item(obj) {
    let image = '';
    let itemClass = 'awesomplete__item';

    if (typeof obj.label.image !== 'undefined') {
      image = `
        <div class="awesomplete__image">
          <img src="${obj.label.image}" alt="${obj.label.label}" />
        </div>
      `;
    }

    if (typeof obj.label.class !== 'undefined') {
      itemClass += ` ${obj.label.class}`;
    }

    return $('<li>', {
      html: `
        <div class="awesomplete__inner">
          ${image}
          <strong class="d-block">${obj.label.label}</strong>
        </div>
      `,
      'aria-selected': 'false',
      class: itemClass,
    })[0];
  }

  onResize() {
    this.throttledResize();
  }

  onKeyup(e) {
    if (IGNORED_KEYS.indexOf(e.keyCode) >= 0) {
      return;
    }

    const searchQuery = e.target.value;
    this.debouncedSearch(searchQuery);
  }

  search(searchQuery) {
    $.ajax({
      url: `${this.data.get('api')}?q=${searchQuery}`,
      dataType: 'json',
      success: (data) => {
        this.awesomplete.list = data.items;
        this.awesomplete.evaluate();
      },
    });
  }

  replace(obj) {
    if (typeof obj.value.redirect_url !== 'undefined') {
      window.location = obj.value.redirect_url;
      return;
    }

    this.inputTarget.value = obj.value.label;

    if (this.element) {
      this.element.submit();
    }
  }

  changePlaceholder() {
    const shouldChangePlaceholder = Modernizr.mq(`(min-width: ${BREAKPOINT}px)`);
    const { placeholderShort } = this.inputTarget.dataset;
    const { placeholderLong } = this.inputTarget.dataset;

    this.inputTarget.placeholder = shouldChangePlaceholder ? placeholderLong : placeholderShort;
  }
}

Search.targets = [
  'input',
  'submit',
];

export default Search;
